import { IOrder } from 'next-common';
import { IPCodeWarnFlags } from '../../common';
import { IconType, MessageBar } from '@repo/ui/components';
import { TMessageBarSeverity } from 'types';

export interface IPCodeInValiidDateWarningProps {
  order: IOrder;
  warning: IPCodeWarnFlags;
}

export const PCodeValidationWarning = (props: IPCodeInValiidDateWarningProps) => {
  const getInvalidPCodeWarningMessage = () => {
    if (props.order?.isEditOrder) {
      return `Kontrakten inneholder opsjoner som ikke lenger er tilgjengelige fra importør  Du må oppdatere kontrakten og innhente ny signatur fra kunde`;
    } else {
      return `Tilbudet inneholder opsjoner som ikke lenger er tilgjengelige fra importør. Du må fjerne opsjonene fra tilbudet og informere kunde`;
    }
  };

  const getVehicleStatusMismatchWarningMessage = () => {
    if (props.order?.isEditOrder) {
      return `Konfigurasjonen er endret på kjøretøyet i etterkant av at kontrakten ble inngått, endringen er sannsynligvis utført av ordrekontoret. Du må oppdatere kontrakten og innhente ny signatur fra kunde`;
    } else {
      return `Konfigurasjonen er endret på kjøretøyet i etterkant av at tilbudet ble gitt, endringen er sannsynligvis utført av ordrekontoret. Du må informere kunde og oppdatere tilbudet`;
    }
  };

  const getMasterAPIMismatchWarningMessage = () => {
    if (props.order?.isEditOrder) {
      return `Kontrakten inneholder en opsjon som ikke lenger kan tilbys, du må oppdatere kontrakten og innhente ny signatur fra kunde`;
    } else {
      return `Tilbudet inneholder en opsjon som ikke lenger kan tilbys, du må informere kunde og oppdatere tilbudet`;
    }
  };

  const priceMismatchWarningMessage = () => {
    return 'Fant prismisforhold for lokale alternativer. Prisene vil bli oppdatert når neste knapp trykkes.';
  };

  const RenderMessageBar = ({ message }) => (
    <MessageBar alertIcon={IconType.Warning} severity={TMessageBarSeverity.WARNING}>
      <p className="font-semibold" dangerouslySetInnerHTML={{ __html: message }} />
    </MessageBar>
  );

  return (
    <>
      {props.warning?.showDateWarn || props.warning?.showTTCodeWarn ? (
        <RenderMessageBar message={getInvalidPCodeWarningMessage()} />
      ) : null}
      {props.warning?.showMasterAPIMismatchWarn ? (
        <RenderMessageBar message={getMasterAPIMismatchWarningMessage()} />
      ) : null}
      {props.warning?.showVehicleStatusMismatchWarn ? (
        <RenderMessageBar message={getVehicleStatusMismatchWarningMessage()} />
      ) : null}
      {props.warning?.isPriceMismatch ? <RenderMessageBar message={priceMismatchWarningMessage()} /> : null}
    </>
  );
};
